import React, { ReactElement, useState, useEffect, useMemo } from 'react';
import { Paragraph } from 'utils';

import { FormattedMessage } from 'react-intl';

import {
  Container,
  ServiceItem,
  LandingImage,
  LandingText,
  Card,
  Card02,
  Card03,
  Card03In,
  CardRow,
  CardRow02,
  CardRow03,
  CardRow04,
  ContentView,
  ImageContainer01,
  ImageContainer02,
  TabsWrapper,
  EmptyButton,
  WhiteButton,
  FullButton,
  H2,
  H3,
  TextCard,
  BackgroundImage,
  CardRow01,
  TabListWrapper
} from './styles';
import { Row, Col, Button, Space } from 'antd';
import { Image } from 'semantic-ui-react';

import logo from 'images/payments/quick/landing_02.png';
import channeltalk from 'helpers/channeltalk';
// import { openChat } from 'helpers/cloudgate';

import { Tab, Tabs, TabList, Panel, PanelList } from 'react-swipeable-tab';

// import img01 from 'images/payments/quick/img01.svg';
// import img02 from 'images/payments/quick/img02.svg';
import img01 from 'images/payments/quick/section01.svg';
import img02 from 'images/payments/quick/section02.svg';
import img03 from 'images/payments/quick/img01.jpg';
import img04 from 'images/payments/quick/img02.jpg';
import img05 from 'images/payments/quick/img03.jpg';

import bn01 from 'images/payments/quick/bn01.svg';
import bn02 from 'images/payments/quick/bn02.svg';
import bn03 from 'images/payments/quick/bn03.svg';

import Tax from 'images/payments/quick/Tax.png';
// import Discount from 'images/payments/quick/Discount.png';
import Discount from 'images/payments/quick/img_Discount.svg';

import { CAPTAIN_PAYMENT } from 'apis';
import { useQuery } from 'react-query';
import storage from 'helpers/storage';
import api from 'config';

import { checkUseService } from './utils';
import { useMount } from 'react-use';
const isIE = /*@cc_on!@*/ false || !!document.documentMode;

interface QuickLandingProps {}

function QuickLanding({ history }: QuickLandingProps): ReactElement {
  const [activeIndex, setActiveIndex] = useState(0);

  const { isLoading, data, isSuccess, isError, error } = useQuery('GetPublicService', CAPTAIN_PAYMENT.GetPublicService);

  const startAgreement = () => {
    var v = checkUseService('QUICK', data.serviceMenuList);
    if (v) return _startQuick();
    history.push('/service/quick/reservation/booking');
  };

  const _startQuick = () => {
    history.push('/service/quick/reservation/booking');
  };

  const isUseQuick = useMemo(() => {
    if (!isSuccess) return;
    var v = checkUseService('QUICK', data.serviceMenuList);
    if (v) _startQuick();
  }, [isSuccess]);

  if (!isSuccess) {
    return <div></div>;
  }

  return (
    <Container isIE={isIE}>
      <LandingImage>
        <BackgroundImage logo={logo} />
        {/* <Parallax bgImage={logo} bgImageAlt="대장마켓플레이스" strength={400}></Parallax> */}

        <div className="linear"></div>
        <LandingText>
          <h2>
            <Paragraph id="QuickLandingSlogan" />
          </h2>
          <h3>
            <FormattedMessage id="quick.slogan.desc.01" />
            <br />
            <FormattedMessage id="quick.slogan.desc.02" />
          </h3>
          <Space>
            <EmptyButton type="primary" className="login-form-button-channel" onClick={() => channeltalk.openChat()}>
              <FormattedMessage id="1:1" />
            </EmptyButton>
            <FullButton type="primary" onClick={startAgreement}>
              <FormattedMessage id="start.button" />
            </FullButton>
          </Space>
        </LandingText>
      </LandingImage>
      <CardRow01>
        <ImageContainer01>
          <Image src={img01} />
        </ImageContainer01>

        <ImageContainer01>
          <Image src={img02} />
        </ImageContainer01>
      </CardRow01>

      <CardRow02 justify="center" style={{ margin: 0 }}>
        <h2>
          <Paragraph id="QuickLandingTitle03" />
        </h2>
        <Card03 xs={24} sm={12} md={12} lg={8} xl={8} style={{ marginTop: '20px' }}>
          <Image src={bn02} style={{ width: '100%' }} />
          {/* <ScrollAnimation animateIn="fadeIn" duration={1}>
              <Image src={bn01} />
            </ScrollAnimation> */}
        </Card03>
        <Card03 xs={24} sm={12} md={12} lg={8} xl={8} style={{ marginTop: '20px' }}>
          <Image src={bn01} style={{ width: '100%' }} />
          {/* <ScrollAnimation animateIn="fadeIn" duration={1}>
              <Image src={bn02} />
            </ScrollAnimation> */}
        </Card03>
        <Card03 xs={24} sm={12} md={12} lg={8} xl={8} style={{ marginTop: '20px' }}>
          <Image src={bn03} style={{ width: '100%' }} />
          {/* <ScrollAnimation animateIn="fadeIn" duration={1}>
              <Image src={bn03} />
            </ScrollAnimation> */}
        </Card03>
      </CardRow02>

      {!isIE ? (
        <div>
          <CardRow style={{ textAlign: 'center' }}>
            <Col span={24}>
              <div>
                <h2>
                  <Paragraph id="QuickLandingTitle04" />
                </h2>
              </div>
              <div style={{ marginBottom: '40px' }}>
                <h3>
                  <Paragraph id="QuickLandingDesc04" />
                </h3>
              </div>

              <div style={{ borderRadius: '8px' }}>
                <TabsWrapper
                  activeIndex={activeIndex}
                  onTabChange={setActiveIndex}
                  style={{ display: 'flex', flexDirection: 'column' }}
                >
                  <TabList
                    style={{
                      background: '#F3F5F6',
                      borderRadius: '10px',
                      padding: '8px',
                      width: '600px',
                      alignSelf: 'center'
                    }}
                  >
                    <Tab>
                      <Paragraph id="QuickLandingTitle0401" />
                    </Tab>
                    <Tab>
                      <Paragraph id="QuickLandingTitle0402" />
                    </Tab>
                    <Tab>
                      <Paragraph id="QuickLandingTitle0403" />
                    </Tab>
                  </TabList>

                  <PanelList style={{ height: '500px', borderRadius: '8px' }}>
                    <div style={{ position: 'absolute', width: '100%', height: '100%', zIndex: 99 }}></div>
                    <Panel>
                      <div>
                        <Image src={img03} />
                      </div>
                    </Panel>

                    <Panel>
                      <div>
                        <Image src={img04} />
                      </div>
                    </Panel>
                    <Panel>
                      <div>
                        <Image src={img05} />
                      </div>
                    </Panel>
                  </PanelList>
                </TabsWrapper>
              </div>
            </Col>
          </CardRow>
        </div>
      ) : (
        undefined
      )}

      <CardRow02
        justify="center"
        style={{
          background: '#EAF3FF',
          textAlign: 'center',
          margin: 0,
          padding: '60px 120px 60px 120px'
        }}
      >
        <h2>
          <Paragraph id="QuickLandingTitle05" />
        </h2>
        <h3 style={{ paddingBottom: '10px' }}>
          <Paragraph id="QuickLandingDesc05" />
        </h3>
        <Card03 xs={24} sm={12} md={12} lg={12} xl={12}>
          <ImageContainer02 style={{ background: 'transparent' }}>
            <Image src={Tax} />
          </ImageContainer02>
        </Card03>
      </CardRow02>

      <CardRow02 justify="center" style={{ backgroundColor: '#fff', paddingBottom: '30px', textAlign: 'center' }}>
        <h2>
          <Paragraph id="QuickLandingTitle055" />
        </h2>
        <h3>
          <Paragraph id="QuickLandingDesc055" />
        </h3>
        <Card03 xs={24} sm={12} md={12} lg={12} xl={12}>
          <ImageContainer02 style={{ background: 'transparent' }}>
            <Image src={Discount} style={{ width: '100%' }} />
          </ImageContainer02>
        </Card03>
      </CardRow02>

      <CardRow04>
        <div>
          <h3 style={{ marginBottom: 8 }}>
            <Paragraph id="QuickLandingTitle06" />
          </h3>
        </div>
        <div>
          <h2 style={{ color: '#fff' }}>
            <Paragraph id="QuickLandingDesc06" />
          </h2>
        </div>
        <div>
          <WhiteButton style={{ marginTop: '16px' }} onClick={startAgreement}>
            <FormattedMessage id="quick.start.button" />
          </WhiteButton>
        </div>
      </CardRow04>
    </Container>
  );
}

export default QuickLanding;
